import React, { Component } from "react";
import { Container, Row, Col, CardImg } from "reactstrap";
import './style.css';
import { Helmet } from "react-helmet";

import FAQ from '../../../FAQ/faq';
import faqs from './qa';

import CourseHero from "../../CourseComponents/Hero/courseHero";
import BackgroundImage from "../../../images/fs2-v2.png";
import HowToApply from "../../CourseComponents/How-To-Apply/how-to-apply";
import CourseOverview from "../../CourseComponents/CourseOverview/courseOverview";
import WeekOverview from "../../CourseComponents/WeekOverview/weekOverview";
import WeekCard from "../../CourseComponents/WeekCards/weekCard";
import CareerSupport from "../../CourseComponents/CareerSupport/careerSupport";
import ProgramDates from "../../CourseComponents/ProgramDates/programDates";
import ProgramCard from "../../CourseComponents/ProgramCard/programCard";
import FinanceOptions from "../../CourseComponents/FinanceOptions/financeOptions";

export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courseName: "Full Stack Web Development",
      courseType: "Intensive",
      courseHours: "Part-Time",
      overview: {
        time: "Part-Time",
        weeks: "26 Weeks",
        teaser: "Adding To Your Skills Set With Coding Fundamentals  ",
        hours: "200 Hours",
        overview: `Our Full Stack Web Development course was built for students to
                  evolve from being neophytes to employment-ready,
                  Full-Stack developers. You’ll end this course
                  equipped with experience with different languages,
                  frameworks and libraries that meet the needs of employers,
                  along with a solid foundation of fundamental programming
                  and computer knowledge.`
      },
      weeksubtext: `Dive into the software development environment and the
                    basics of computing, networks, and data structures. Discover
                    how to build applications that meet user needs, model data,
                    develop wireframes, and work collaboratively through version
                    control.`,
      card1: {
        title: "Week 1 - 7",
        subtitle: "Front-End Technologies",
        topics: ["HTML5", "CSS3", "Javascript"]
      },
      card2: {
        title: "Week 8 - 14",
        subtitle: "Back-end Technologies",
        topics: ["Node.js", "Express", "MongoDB"]
      },
      card3: {
        title: "Week 15 - 21",
        subtitle: "Fullstack Development",
        topics: [
          "Building Fullstack Applications",
          "Deploy application to share with the world"
        ]
      },
      card4: {
        title: "Week 22 - 26",
        subtitle: "Capstone Project",
        topics: [
          "Working with Clients",
          "Capstone Project",
          "Portfolio Building"
        ]
      }
    };
  }
  render() {
    return (
      <div className="overflow">
           <Helmet>
          <meta charSet="utf-8" />
          <title>Lighthouse</title>
          <link rel="canonical" href="http://atlighthouse.com" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Lighthouse"></meta>
          <meta property="og:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta property="og:url" content="https://atlighthouse.com"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@at_lighthouse"></meta>
          <meta name="twitter:title" content="Lighthouse"></meta>
          <meta name="twitter:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta name="twitter:url" content="https://atlighthouse.com"></meta>
          <meta
            name="description"
            content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."
          />
  
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta
            name="keywords"
            content="Coding Bootcamps, Technology Bootcamps, Tech bootcamps, Business and technology bootcamps, 
              Business bootcamps, Bootcamp, Programming, Become a Developer, Become a Software Developer, Learn Code,
              Get Hired for coding, Immersive program, Intensive program, Atlanta Coding bootcamps, Best coding bootcamps,Top coding bootcamps in Atlanta, Free coding bootcamp, Job guarantee bootcamp, Bootcamp with job guarantee,
              Steps to becoming a developer, Steps to becoming a web developer, Steps to becoming a software engineer, How to become a developer, How to become a programmer, How to become a web developer, How to become a full stack web developer, How to become a full stack developer, How to become a software developer, How to become a software engineer, How to become a data scientist, How to become a data analyst, How to become a digital marketer, How to become a UX designer, How to become an experience designer, How to become a UI designer, Coding bootcamp with job guarantee, Full time coding bootcamps, Part time coding bootcamps, Learn full stack web development, Learn web development, Learn software engineering, Learn data science, Learn data analytics, Learn digital marketing, Learn experience design, Learn ux design, Learn ui design, Full Stack Web Development Course, Full Stack Web Development Bootcamp, Full Stack Web Development Program, Full Stack Web Development Certificate, Atlanta Full Stack Development Course, Atlanta Full Stack Development Bootcamp, Atlanta Full Stack Development Program, Atlanta Full Stack Development Certificate, Data Science Course, Data Science Bootcamp, Data Science Program, Data Science Certificate, Atlanta Data Science Course, Atlanta Data Science Bootcamp, Atlanta Data Science Program, Atlanta Data Science Certificate, Software Engineering Course, Software Engineering Bootcamp, Software Engineering Program, Software Engineering Certificate, Atlanta Software Engineering Course, Atlanta Software Engineering Bootcamp, Atlanta Software Engineering Program, Atlanta Software Engineering Certificate, Digital Marketing Course, Digital Marketing Bootcamp, Digital Marketing Program, Digital Marketing Certificate, Atlanta Digital Marketing Course, Atlanta Digital Marketing Bootcamp, Atlanta Digital Marketing Program, Atlanta Digital Marketing Certificate, UX Course, UX Certificate, UX Bootcamp, UX Program, Atlanta UX Course, Atlanta UX Certificate, Atlanta UX Bootcamp, Atlanta UX Program, Competitive programming, How to get a job in programming, Bootcamps for college students, Coding bootcamps for college students, Best coding bootcamps in atlanta, Top rated coding bootcamps in atlanta, Top rated coding bootcamps, Best coding bootcamps, Rigorous coding bootcamps, Data Science bootcamps for college students, Best Data Science bootcamps in atlanta, Top rated Data Science bootcamps in atlanta, Top rated Data Science bootcamps, Best Data Science bootcamps, Can you get a job out of a coding bootcamp?, Talent Marketplace, Technology skills, Technology career, Career in software engineering, Career in data science, Career in digital marketing, Career in ux design, Career, Learn, Programming, Coding, Machine learning courses, Web development courses"
          />
          <meta name="theme-color" content="#000000" />
        </Helmet>
        <CourseHero
          courseName={this.state.courseName}
          courseType={this.state.courseType}
          courseHours={this.state.courseHours}
          cName='webdev-int-jumbo'
          source='web-dev-req-syl'
        />

        <div className="all-pages">
          <CourseOverview
            time={this.state.overview.time}
            weeks={this.state.overview.weeks}
            hours={this.state.overview.hours}
            overview={this.state.overview.overview}
            teaser={this.state.overview.teaser}
          >
            <CardImg
              className="rounded-0"
              top
              height="auto"
              src="img/full-stack-icon-v2.png"
              alt="Card image cap"
            />
          </CourseOverview>

          <section>
            <Container>
                <Row>
                    <Col xs={{ size: 12 }} lg={{ size: 11, offset: 1}} className="left-align ditl-headline ">
                      <h1 className="">
                        {" "}
                        Designed to Balance Busy Work Schedules
                      </h1>
                    </Col>
                </Row>

                <Row >
                  <Col lg={{ size: 5,offset: 1 }}>
                    <Row className=" left-align pt-5">
                      <Col xs={{ size: 11 }} lg={{ size: 11 }}>
                        <p>
                          Scheduled for two evening week days plus
                          a Saturday morning, our intensive course is perfect
                          for students who are looking for something to fit into
                          their current work schedule.{" "}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        className="ditl-list left-align pl-0 pr-0  text-lg-left"
                        xs={{ size: 5 }}
                      >
                        <h3 className="pl-3 yellow">Evenings</h3>
                        {" "}
                        <ul className="py-0">
                          <li>Standups</li>
                          <li>Lectures and Labs</li>
                          <li>Coding Challenges</li>
                      
                        </ul>{" "}
                      </Col>
                      <Col
                        className="ditl-list left-align ml-4  text-lg-left"
                        xs={{ size: 5 }}
                      >
                       <h3 className="yellow pl-0 text-left text-lg-left">Weekends</h3>
                        <ul className="py-0 pl-0">
                        
                          <li>Meetups</li>
                          <li>Project TIme</li>
                          <li>Career Coaching</li>
                        </ul>
                      </Col>
                    </Row>
                  </Col>
                  <Col className="d-none d-lg-block" md={{ size: 5 }}>
                    <CardImg
                      className="clear-card"
                      top
                      width="100%"
                      src="img/fs2-collage-v2.png"
                      alt="Card image cap"
                    />
                  </Col>
                </Row>
            </Container>
          </section>

          <WeekOverview subtext={this.state.weeksubtext}>
          <Container>
            <Row>
              <WeekCard
                sm="6"
                lg="3"
                title={this.state.card1.title}
                subtitle={this.state.card1.subtitle}
                topics={this.state.card1.topics}
              />
              <WeekCard
                sm="6"
                lg="3"
                title={this.state.card2.title}
                subtitle={this.state.card2.subtitle}
                topics={this.state.card2.topics}
              />
              <WeekCard
                sm="6"
                lg="3"
                title={this.state.card3.title}
                subtitle={this.state.card3.subtitle}
                topics={this.state.card3.topics}
              />
              <WeekCard
                sm="6"
                lg="3"
                title={this.state.card4.title}
                subtitle={this.state.card4.subtitle}
                topics={this.state.card4.topics}
              />
            </Row>
            </Container>
          </WeekOverview>

          <CareerSupport>
            <CardImg
              className="career-support-img"
              top
              height="100%"
              width="100%"
              src="img/web-career2-v2.png"
              alt="Card image cap"
            />
          </CareerSupport>

          <HowToApply />
          <ProgramDates>
          <ProgramCard
              days="Dec 9, 2019 - Jun 12, 2020"
              time="Mon to Fri: 9:00AM - 5:00PM"
              exclude="Excluding: Dec 23 - Dec 27, Dec 30, Dec31, Jan 1, Feb 17, April 13, May 25"
            />
            <ProgramCard
              days="Feb 3, 2019 - Aug 5, 2020"
              time="Mon to Fri: 9:00AM - 5:00PM"
              exclude="Excluding: Feb 17, April 13, May 25"
            />
          </ProgramDates>

          <FinanceOptions tuition="$9,950" />

          <FAQ faqs={faqs} />
        </div>
      </div>
    );
  }
}
